import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { getRelatedByTheme, type BlogPost } from "@/pages/blog/blogData";

export default function RelatedByTheme({ post }: { post: BlogPost }) {
  const groups = getRelatedByTheme(post, 3, 5);
  if (groups.length === 0) return null;

  return (
    <section
      aria-label="Artigos relacionados por tema"
      className="mt-14 rounded-2xl border border-background-200 bg-background-100/70 p-6 md:p-8"
    >
      <div className="flex items-center gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
          <i className="ri-links-line text-lg" aria-hidden="true"></i>
        </span>
        <div>
          <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
            Artigos relacionados por tema
          </h2>
          <p className="mt-1 text-sm text-foreground-600">
            Continue navegando por assuntos ligados a este conteúdo.
          </p>
        </div>
      </div>

      <div className="mt-7 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {groups.map((group) => (
          <Reveal key={group.tag}>
            <div className="h-full rounded-xl border border-background-200 bg-background-50 p-5">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
                <i className="ri-price-tag-3-line" aria-hidden="true"></i>
                {group.tag}
              </span>
              <ul className="mt-4 space-y-3">
                {group.posts.map((item) => (
                  <li key={item.slug}>
                    <Link
                      to={`/blog/${item.slug}`}
                      className="group flex items-start gap-2 text-sm font-medium text-foreground-800 transition-colors hover:text-primary-600"
                    >
                      <i
                        className="ri-arrow-right-s-line mt-0.5 shrink-0 text-primary-500 transition-transform group-hover:translate-x-0.5"
                        aria-hidden="true"
                      ></i>
                      <span>{item.title}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}